import * as React from 'react';
import { FormGroup, Label } from './styles/common';

export function FormInputNumber({
  label,
  registration,
  error,
  valid,
  min,
  max,
  step = 1, // Default step is 1
}) {
  return (
    <FormGroup>
      {label !== undefined && <Label>{label}</Label>}
      <input
        min={min}
        max={max}
        step={step} // Include the step attribute
        className={`form-control mb-1 text-center ${
          error ? 'is-invalid' : ''
        } ${valid ? 'is-valid' : ''}`}
        type="number"
        {...registration}
      />
      <div className="invalid-feedback m-0">{error}</div>
    </FormGroup>
  );
}
